define('glu/grid/cell/singleRowSelectorCell',['require','../../itemView','../../util','../../$document','hbs!./singleRowSelectorCell.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        util = require('../../util'),
        $document = require('../../$document'),
        tpl = require('hbs!./singleRowSelectorCell.hbs');

    return ItemView.extend({
        template: tpl,

        ui: {
            rowSelector: '.column-row-selector'
        },

        events: {
            'change @ui.rowSelector': 'handleSelectRowChange'
        },

        handleSelectRowChange: function(e) {
            util.each(this.$el.closest('tbody').find('input[name="single-row-selector"]'),
                function(el) {
                    var $el = $document.find(el);
                    $el.closest('tr').toggleClass('selected', $el.is(':checked'));
                }, this);

            // Broadcast the row select event.
            this.appBus.trigger('grid:selectRow', this);
        },

        templateHelpers: function() {
            return {
                id: this.model.cid,
                value: this.options.value
            };
        }

    });
});

